import { Component, OnInit } from '@angular/core';
import { Request } from '../../_service/request';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(
    private request: Request,
  ) { }

  ngOnInit(): void {
    this.getCurrency_list()
  }

  c_type: any;
  selected_asset: any;
  selected_currency: any;
  selected_currency_img: any;
  serverUrl = this.request.server_url;
  movePageTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  async getCurrency_list() {
    let temp = this.request.get_structure('get_currency_list', 'format');
    temp = await this.request.post(0, 'get_currency_list', temp);
    console.log(temp);
    if (temp[0] == 200) {
      this.c_type = temp[1]['response']['data']['currencies'];
      console.log(this.c_type)
      if (localStorage.getItem('c_type')) {
        let currency_id = localStorage.getItem('c_type');
        this.selected_asset = [...this.c_type];
        this.selected_asset = this.selected_asset.filter(data => {
          if (data.id.includes(currency_id)) {
            return data
          }
        })
        if (localStorage.getItem('c_type') == "1") {
          this.selected_currency = "Convert Currency"
        } else {
          this.selected_currency = this.selected_asset[0]['currency']
          this.selected_currency_img = this.selected_asset[0]['currency_icon']
        }
      } else {
        console.log('called', this.c_type[0].id)
        localStorage.setItem('c_type', this.c_type[0].id);
        let currency_id = localStorage.getItem('c_type');
        this.selected_asset = [...this.c_type];
        this.selected_asset = this.selected_asset.filter(data => {
          if (data.id.includes(currency_id)) {
            return data
          }
        })
        if (localStorage.getItem('c_type') == "1") {
          this.selected_currency = "Convert Currency"
        } else {
          this.selected_currency = this.selected_asset[0]['currency']
          this.selected_currency_img = this.selected_asset[0]['currency_icon']
        }
        this.selected_asset = localStorage.getItem('c_type');
      }
    }
  }

  selectedAsset(value) {
    this.selected_asset = [...this.c_type];
    this.selected_asset = this.selected_asset.filter(data => {
      if (data.id.includes(value.id)) {
        return data
      }
    })
    console.log(this.selected_asset)
    if (localStorage.getItem('c_type') == "1") {
      this.selected_currency = "Convert Currency"
    } else {
      this.selected_currency = this.selected_asset[0]['currency']
      this.selected_currency_img = this.selected_asset[0]['currency_icon']
    }
    localStorage.setItem('c_type', this.selected_asset[0]['id']);
    window.location.reload();
  }

}
